import { useAccount } from '@azure/msal-react';
import { Avatar, Menu, Stack, Text } from '@mantine/core';
import { IconBookmark } from '@tabler/icons-react';
import { Link } from '@tanstack/react-router';
import { use } from 'react';

import { ProjectContext } from '#core/contexts/ProjectContext.ts';

import { ColorSchemeToggleButton } from './ColorSchemeToggleButton.tsx';
import classes from './UserMenu.module.css';

export function UserMenu() {
  const account = useAccount();
  const { config } = use(ProjectContext);

  return (
    <Menu position="right" shadow="md" withArrow>
      <Menu.Target>
        <Avatar className={classes.avatar} color="dark.5" variant="filled" />
      </Menu.Target>

      <Menu.Dropdown>
        {account && (
          <Menu.Item component="button">
            <Stack align="flex-start" gap={0}>
              <Text fw={500} size="sm">
                {account?.name}
              </Text>

              <Text c="dimmed" size="xs">
                {account?.username}
              </Text>
            </Stack>
          </Menu.Item>
        )}
        <Menu.Item>
          <ColorSchemeToggleButton />
        </Menu.Item>

        <Menu.Divider />

        {config.feature.ai.enabled && (
          <Menu.Item component={Link} leftSection={<IconBookmark size={14} />} to="/bookmarks">
            My Dashboards
          </Menu.Item>
        )}
      </Menu.Dropdown>
    </Menu>
  );
}
